/**
 * Created by glenn on 7/21/2017.
 */
import * as store from './store';
import {makeBlueGreenRedGradient} from 'webmapsjs/dist/util/colors';
import Feature from 'ol/Feature';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import LayerBaseVectorGeoJson from "webmapsjs/dist/layers";



export const popupFunc = (p) => {

    let state: store.iStore = store.store.getState() as store.iStore;

    let returnHtml = '';

    returnHtml += '<table>';
    returnHtml += `<tr><td>Route Type</td><td>${p['RouteName']}</td></tr>`;
    returnHtml += `<tr><td>Road</td><td>${p['RouteNum']}</td></tr>`;

    let direction = '';

    switch (p['Dir']) {
        case 'E':
            direction = 'Eastbound';
            break;
        case 'W':
            direction = 'Westbound';
            break;
        case 'S':
            direction = 'Southbound';
            break;
        case 'N':
            direction = 'Northbound';
            break;
        default:
            break;
    }

    returnHtml += `<tr><td>Direction</td><td>${direction}</td></tr>`;
    returnHtml += `<tr><td>Year</td><td>${p['Year']}</td></tr>`;

    returnHtml += `<tr><td>Data</td><td>${store.lookupDataTypes[state['dataType']]}</td></tr>`;
    returnHtml += `<tr><td>Time</td><td>${store.lookupTimePeriods[state['valsTimePeriod']]}</td></tr>`;
    returnHtml += `<tr><td>Display</td><td>${store.lookupDisplayMethods[state['displayMethod']]}</td></tr>`;

    let dataYear = state.data.data[p['RouteNum']][state.year.toFixed()];

    if (dataYear) {
        let val = dataYear[p['Dir']][state.dataType][state.timePeriod][state.displayMethod];
        let d = '';

        switch (val) {
            case -1:
                d = 'N/A (No Detector)';
                break;
            case -2:
                d = 'Unknown (Data Not Released)';
                break;
            case -3:
                d = 'Data Available, Not Processed';
                break;
            default:
                d = val.toFixed(2)
        }
        returnHtml += `<tr><td>Value</td><td>${d}</td></tr>`;


    }
    // let val = 'No Data';
    // if (typeof p[combo] === "undefined" || p[combo] == null || p[combo] < 0){
    //     //pass
    // } else {
    //     val = p[combo].toFixed(2);
    // }
    //
    // returnHtml += `<tr><td>Value:</td><td>${val}</td></tr>`;
    returnHtml += '</table>';

    return returnHtml;
};

export const colorNa = '#C5C5C5';
export const colorUnknown = '#7D7D7D';
export const colorNotDet = '#373737';

interface iProps {
    Dir: string;
    RouteName: string;
    RouteNum: string;
    Year: number;
    offset: number;
}

export const style = (feature: Feature, res: number): Style[] => {

    let props: iProps = feature.getProperties() as iProps;

    if (res > 10 && props.offset != 200) {
        return null;
    } else if (res < 2 && props.offset != 0) {
        return null;
    } else if (res > 2 && res < 3 && props.offset != 20) {
        return null;
    } else if (res > 4 && res < 5 && props.offset != 50) {
        return null;
    } else if (res > 5 && res < 10 && props.offset != 100) {
        return null;
    }

    let state: store.iStore = store.store.getState() as store.iStore;

    if (props.Year != state.year) {
        return null;
    }

    if (!state.data){
        return undefined;
    }

    if (!state.data.data){
        return undefined;
    }

    let dataYear = state.data.data[props['RouteNum']][state.year.toFixed()];

    if (!dataYear) {
        return null;
    }

    let val = dataYear[props['Dir']][state.dataType][state.timePeriod][state.displayMethod];

    let stats = state.data.stats[state.year.toFixed()][state.dataType][state.timePeriod][state.displayMethod];

    let color = colorNa;

    if (val == -1) {
        color = colorNa;
    } else if (val == -2) {
        color = colorUnknown;
    } else if (val == -3) {
        color = colorNotDet
    } else if (!stats) {
        color = colorNa;
    }  else if (stats.min != stats.max) {
        let grad = makeBlueGreenRedGradient(stats.min, stats.max, true);
        color = grad(val);
    }

    let s = new Style({
        stroke: new Stroke({
            // color: 'blue',
            color: color,
            width: 5
        })
    });

    return [s];
};